<template>
    <div>
        <p>We will ask you specifics of the device and incident at a later stage.</p>
        <div class="col">
            <div class="container-fluid">
                <div class="row claim-form-grid-row">
                <div v-for="(type, index) in incidentTypes" :key="'incidentType_' + index" class="grid-item">
                    <div :class="getCardClass(selectedIncidentType, type)" @click="handleTypeClick(type)">
                        <div class="incident-card-inner-content">
                            <i :class="type.icon" class="row"></i>
                            <h4 class="">{{type.label}}</h4>
                        </div>              
                    </div>
                </div>
                </div>

                <input 
                    id="incidentTypeId" 
                    type="text" 
                    v-model="selectedIncidentTypeId" 
                    style="display: none; max-height:0;" 
                    v-taurus-validator="'required'" 
                    fieldlabel="incident type">
                <div name="incidentTypeId" invalidfeedback="Please select the type of claim you are making"></div>
            </div>
            
            <div ref="childTypes">
                <div v-if="selectedIncidentType && selectedIncidentType.children" class="container-fluid">
                    <p>Please narrow down your selection below...</p>
                    <div class="row claim-form-grid-row">
                        <div v-for="(type, index) in selectedIncidentType.children" :key="'incidentTypeChild_' + index" class="grid-item">
                            <div :class="getCardClass(selectedIncidentTypeChild, type)" @click="handleTypeChildClick(type)">
                                <div class="incident-card-inner-content">
                                <i :class="type.icon" class="row"></i>
                                <h4 class="">{{type.label}}</h4>
                                </div>                
                            </div>
                        </div>
                    </div>
                    <input 
                        id="incidentTypeChildId" 
                        type="text" 
                        v-model="selectedIncidentTypeChildId" 
                        style="display: none; max-height:0;" 
                        v-taurus-validator="'required'" 
                        fieldlabel="incident child type">
                <div name="incidentTypeChildId" invalidfeedback="Please select the type of claim you are making"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import selectableCard from "@/components/standaloneForm/SelectableCard";
    import { smoothScrollTo } from "@/util/smoothScroll.js";
    export default {
        props: {
        },
        components: {
            selectableCard
        },
        data() {
            return {
            incidentTypes: [
                {
                id: 1000,
                level: 1,
                parentId: null,
                label: "Accidental damage",
                icon: "fas fa-band-aid",
                children: [
                    {
                    id: 1004,
                    level: 2,
                    parentId: 1000,
                    label: "Impact damage",
                    icon: "fas fa-compress"
                    },
                    {
                    id: 1005,
                    level: 2,
                    parentId: 1000,
                    label: "Liquid damage",
                    icon: "fas fa-tint"
                    },
                    {
                    id: 1006,
                    level: 2,
                    parentId: 1000,
                    label: "Other",
                    icon: "fas fa-question-circle"
                    }
                ]
                },
                {
                id: 1001,
                level: 1,
                parentId: null,
                label: "Theft",
                icon: "fas fa-user-secret",
                children: [
                    {
                    id: 1007,
                    level: 2,
                    parentId: 1001,
                    label: "At home",
                    icon: "fab fa-houzz"
                    },
                    {
                    id: 1008,
                    level: 2,
                    parentId: 1001,
                    label: "At work",
                    icon: "fas fa-industry"
                    },
                    {
                    id: 1009,
                    level: 2,
                    parentId: 1001,
                    label: "In a public place",
                    icon: "fas fa-users"
                    },
                    {
                    id: 1010,
                    level: 2,
                    parentId: 1001,
                    label: "On public transport",
                    icon: "fas fa-bus"
                    }
                ]
                },
                {
                id: 1002,
                level: 1,
                parentId: null,
                label: "Loss",
                icon: "fas fa-question-circle",
                children: [
                    {
                    id: 1011,
                    level: 2,
                    parentId: 1002,
                    label: "At home",
                    icon: "fab fa-houzz"
                    },
                    {
                    id: 1012,
                    level: 2,
                    parentId: 1002,
                    label: "At work",
                    icon: "fas fa-industry"
                    },
                    {
                    id: 1013,
                    level: 2,
                    parentId: 1002,
                    label: "In a public place",
                    icon: "fas fa-users"
                    },
                    {
                    id: 1014,
                    level: 2,
                    parentId: 1002,
                    label: "On public transport",
                    icon: "fas fa-bus"
                    }
                ]
                },
                {
                id: 1003,
                level: 1,
                parentId: null,
                label: "Mechanical breakdown",
                icon: "fas fa-wrench"
                }
            ],

            selectedIncidentType: null,
            selectedIncidentTypeId: null,
            selectedIncidentTypeChild: null,
            selectedIncidentTypeChildId:null,
            nextAttempted: false
            };
        },
        computed: {
            isIncidentTypeValid() {
                return this.selectedIncidentType != null;
            },
            selectedIncidentTypeHasChildren() {
                if (this.selectedIncidentType) {
                    return (
                    this.selectedIncidentType.children &&
                    this.selectedIncidentType.children.length > 0
                    );
                }
                return false;
            },
            isIncidentTypeChildValid() {
                return this.selectedIncidentTypeChild != null;
            },
            incidentTypeClass() {
                let klass = {}
                //klass['invalid-feedback'] = true;
                klass['invalid-feedback d-block'] = this.nextAttempted && !this.isIncidentTypeValid;
                return klass
            },
            incidentTypeChildClass() {
                // "nextAttempted && (!isIncidentTypeChildValid & selectedIncidentTypeHasChildren)"
                let klass = {}
                //klass['invalid-feedback'] = true
                klass['invalid-feedback d-block'] = this.nextAttempted && (!this.isIncidentTypeChildValid & this.selectedIncidentTypeHasChildren)
                return klass
            },
            otherClaimsClass() {
                let klass = {}
                //klass['invalid-feedback'] = true
                klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsValid
                return klass
            },
            otherClaimsGadgetDetailsClass() {
                let klass = {}
                //klass['invalid-feedback'] = true
                klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsGadgetDetailsValid
                return klass
            },
            otherClaimsCompanyNameClass() {
                let klass = {}
                //klass['invalid-feedback'] = true
                klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsCompanyNameValid
                return klass
            },
            otherClaimsOutcomeClass() {
                let klass = {}
                //klass['invalid-feedback'] = true
                klass['invalid-feedback d-block'] = this.nextAttempted && !this.isOtherClaimsOutcomeValid
                return klass
            },
            stageTitle() {
                return this.$textManager.getText("title", this.$route.name)
            }
        },
        methods: {
            scrollTo(ref) {
                smoothScrollTo(window, this.$refs[ref], 0, 500);
            },
            getCardClass(selectedType, type) {
                if (selectedType) {
                    return selectedType.id == type.id
                    ? "incident-card-selected incident-card"
                    : "incident-card";
                }

                return "incident-card";
            },
            handleTypeClick(type) {
                this.selectedIncidentType = type;
                this.selectedIncidentTypeId = type.id
                this.$emit('incident-type-selected', type)
                this.selectedIncidentTypeChild = null;
                this.selectedIncidentTypeChildId = null
                this.scrollTo("childTypes");
            },
            handleTypeChildClick(type) {
                this.selectedIncidentTypeChild = type;
                this.selectedIncidentTypeChildId = type.id
                this.$emit('incident-type-selected', type)
            }
        }
    }
</script>